import React, { HTMLProps } from 'react';

export const EVENTS_DELAY = 499;

export interface ScommesseFallbackHookProps {
  isReady: boolean;
  container?: HTMLDivElement | null;
}
export interface ScommesseFallbackHookType {
  showEmpty: boolean;
  showLoader: boolean;
}

export interface ScommesseFallbackProps extends HTMLProps<HTMLElement> {
  isVisible?: boolean;
}

export interface ScommesseEmptyProps extends ScommesseFallbackProps {
  hasFilter: boolean;
  hasRedirect: boolean;
  resetFilter?: () => void;
}

export { Loader } from './Loader';
export { EmptyLive } from './EmptyLive';
export { EmptySport } from './EmptySport';

export { useScommesseFallback } from './useScommesseFallback';